export const DESCARGA_CENTERS = ["C008", "C009"];

export const DESCARGA_REASONS = [
  "15 - Descarga",
  "16 - Descarga Retorno Abertura de Espaço",
];

export const AUTO_ID_ERP_REASONS = [
  "5 - Abastecimento Consumo Interno - Geradores",
  "6 - Abastecimento Consumo Interno - Motor de combate a incêndio",
  "7 - Abastecimento - Outros",
  "10 - Complemento de descarga",
];

export function isDescargaReason(reason: string): boolean {
  return DESCARGA_REASONS.includes(reason);
}

export function isDescargaCenter(centerId: string): boolean {
  return DESCARGA_CENTERS.includes(centerId);
}

export function getOrderTypeLabel(isDescarga: boolean): string {
  return isDescarga ? "descarga" : "carregamento";
}

export function getOrdersPageTitle(orders: { reason: string }[]): string {
  const hasDescarga = orders.some((order) => isDescargaReason(order.reason));
  const hasCarregamento = orders.some(
    (order) => order.reason && !isDescargaReason(order.reason)
  );

  if (hasDescarga && !hasCarregamento) {
    return "Minhas ordens de descarga";
  }

  if (hasDescarga && hasCarregamento) {
    return "Minhas ordens de carregamento e descarga";
  }

  return "Minhas ordens de carregamento";
}

export function getOrderColumnHeader(orders: { reason: string }[]): string {
  const hasDescarga = orders.some((order) => isDescargaReason(order.reason));
  const hasCarregamento = orders.some(
    (order) => order.reason && !isDescargaReason(order.reason)
  );

  if (hasDescarga && !hasCarregamento) {
    return "Ordem de descarga";
  }

  if (hasDescarga && hasCarregamento) {
    return "Ordem";
  }

  return "Ordem de carregamento";
}
